module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.aa137630.png";